export enum ProductMutationTypes {
  UPDATE_PRODUCTS = "UPDATE_PRODUCTS",
  UPDATE_PRODUCT_KEYS = "UPDATE_PRODUCT_KEYS",
  UPDATE_ASSIGNED_USERS = "UPDATE_ASSIGNED_USERS",
  UPDATE_AVAILABLE_PRODUCTS = "UPDATE_AVAILABLE_PRODUCTS",
  UPDATE_SUBSCRIPTIONS = "UPDATE_SUBSCRIPTIONS",
  UPDATE_SHOW_SUBSCRIPTIONDETAILS = "UPDATE_SHOW_SUBSCRIPTIONDETAILS",
  UPDATE_ADDONS_LIST = "UPDATE_ADDONS_LIST",
}
